<template>

  <div :class="['module', 'top', this.item.class, this.item.itemKey, {'is-selected' : this.isSelectedItem}]">

      <Box class="model" v-for="(model_id, index) in schema.models" :mod="model_id" :default-sides="schema.sides" v-bind="get_model(model_id)"/>
      
      <div v-if="showMeasure" class="meta">
        <div class="measure width"><span>{{width}} mm</span></div>
        <div class="measure height"><span>{{height}} mm</span></div>
      </div>

      <Actions class="actions" v-if="showModuleActions" draghandle="drag-handle-item" remove="true" move="true" @moveleft="MOVE_ITEM({old:itemIndex, new:itemIndex-1, group_index:groupIndex})" @moveright="MOVE_ITEM({old:itemIndex, new:itemIndex+1, group_index:groupIndex})" @remove="REMOVE_ITEM({group_index: groupIndex, index:itemIndex})"/>
    
  </div>

</template>

<script>

import { mapGetters, mapActions } from 'vuex'
import { utils } from '@/mixins/utils.js'
import Box from './primitives/Box'
import Actions from '@/components/Actions'

export default {

  name: 'Module',

  mixins:[utils],
  
  props: ['moduleID','item', 'settings', 'itemIndex', 'groupIndex', 'showMeasure', 'showModuleActions'],

  data:function(){
    return{
      variants:{},
      rules:{},
      schema:{},
      errors:[]
    }
  },

  computed:{

    ...mapGetters([
        'selectedItem',
        'all_sections',
        'all_models',
        'all_addons']
    ),

    get_model(id){
     
      return (id) => {
  
          return this.all_models[id];
      }

    },

    isSelectedItem(){
        return this.item === this.selectedItem;
    },

    width(){
      return (this.schema.hasOwnProperty('measure') && this.schema.measure.hasOwnProperty('width'))? this.schema.measure.width : null;
    },

     height(){
      return (this.schema.hasOwnProperty('measure') && this.schema.measure.hasOwnProperty('height'))? this.schema.measure.height : null;
    }

  },

  methods:{

    ...mapActions(['MOVE_ITEM', 'REMOVE_ITEM']),

    /**
     * Check module items rules
     *
     */
    validate(){

      this.errors = [];
      
      for(var key in this.rules){

        var rule = this.rules[key];
      
        try {
        
          if(rule && typeof rule !== 'undefined' && rule.hasOwnProperty('conditions')){
            
            //Test variant conditions
            if(!eval(rule.conditions)){
              this.errors.push(rule.message)
            }

          }

        } catch (error) {
          console.log(error);
          
        }
      }
    },


    // setSize(size){
    //   this.size = size;
    //   this.resolveVariantModels(this.settings, this.item);
    // }
  },

  watch:{
    
    settings: {
      handler (newSettings) {
        this.schema = this.resolveVariantModels();
      },
      deep: true
       
    }
  },

  mounted(){

    //Check if this module is a frame, thus having child items and a size
    if(this.item.hasOwnProperty('items')){
      // console.log('setting size to ' + this.item.items.length);
      //this.size = this.item.items.length;
    }

    this.variants = this.all_sections[this.moduleID].variants;
    this.rules = this.all_sections[this.moduleID].rules;
    this.schema = this.resolveVariantModels();

  },

  components:{
    Box,
    Actions
  }
}
</script>

<style lang="scss">

/* .module:not(.is-selected):not(.is-choosen):not(:active):hover .cube:not(.feature):not(.distance) .face .photon-shader{
    box-shadow: inset 0 0 0 2px rgb(118, 212, 255);
} */
.module.is-selected:not(.is-choosen) .cube:not(.feature):not(.distance):not(.noborder) .face .photon-shader{
    /* box-shadow: inset 0 0 0 2px rgb(118, 212, 255); */
    box-shadow: inset 0 0 0 2px #4DBA87;
}

</style>

<style scoped>

.module{
    position: relative;
    display: inline-block;
    transform-style: preserve-3d;
    vertical-align: bottom;
}

.actions{
    transform: translateZ(var(--actions-offset-z));
    display: none;
    left:50%;
    margin-left: -55px;
    bottom:0;
    position: absolute;
}

.module.is-selected .actions{
    display: block;
}

.module.sortable-chosen {
  transform: translate3d(0, -10px, 0);
}

.module.sortable-chosen .actions{
  display:none;
}


/* Measure styles */

.measure span{
    background:#222222;
    padding:3px 10px;
    color:white;
    border-radius: 30px;
    top:0px;
    position: relative;
    white-space: nowrap;
}

.measure.height span{
    background:#222222;
    padding:3px 10px;
    color:white;
    border-radius: 30px;
    top:50%;
    right:40px;
    position: relative;
}

.stage:not(.show-measure) .measure{
    width:0;
    opacity:0;
}

.measure.width{
    text-align: center;
    left:0;
    right:0;
    width:100%;
    bottom:-35px;
    position: absolute;
    font-weight: bold;
    font-size: 12px;
    height:10px;
    border-bottom:1px dashed #222222;
    border-left:1px dashed #222222;
    border-right:1px dashed #222222;
    transition:50ms;
    z-index:6;
    backface-visibility: hidden;
}

.measure.height{
    text-align: center;
    left:auto;
    left:-50px;
    width:50px;
    bottom:0;
    top:0;
    position: absolute;
    font-weight: bold;
    font-size: 12px;
    height:100%;
    border-left:1px dashed #222222;
    border-top:1px dashed #222222;
    border-bottom:1px dashed #222222;
    transition:50ms;
    z-index:6;
    backface-visibility: hidden;
}

.measure.height::before{
    background:#222222;
    width:10px;
    height:10px;
    display: block;
    position: absolute;
    left:-5px;
    top:0px;
    content:'';
    clip-path: polygon(0 100%, 100% 100%, 50% 0);
}

.measure.height::after{
    background:#222222;
    width:10px;
    height:10px;
    display: block;
    position: absolute;
    left:-5px;
    bottom:0px;
    content:'';
    clip-path: polygon(0 0, 50% 100%, 100% 0%);
}

.measure.width::before{
    background:#222222;
    width:10px;
    height:10px;
    display: block;
    position: absolute;
    left:0;
    top:5px;
    content:'';
    clip-path: polygon(0 50%, 100% 100%, 100% 0);
}

.measure.width::after{
    background:#222222;
    width:10px;
    height:10px;
    display: block;
    position: absolute;
    right:0;
    top:5px;
    content:'';
    clip-path: polygon(0 0, 0 100%, 100% 50%);
}

@media only screen and (max-width: 1087px) {

  /* .actions{
    position: fixed;
    bottom:-40px;
    left:0;
    right:0;
    width:100%;
    display:none;
    transform:translateZ(12em) scale(1.0, 1.0);
    backface-visibility: hidden;
} */

}

@keyframes shake {
  10%, 90% {
    transform: translate3d(-1px, 0, 0);
  }
  
  20%, 80% {
    transform: translate3d(2px, 0, 0);
  }

  30%, 50%, 70% {
    transform: translate3d(-4px, 0, 0);
  }

  40%, 60% {
    transform: translate3d(4px, 0, 0);
  }
}


</style>